const access = [
  {
    path: '/setting/structure',
    name: 'structure-product',
    component: () => import('@/views/setting/structure.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_structure',
      resource: 'all',
    },
  },
  {
    path: '/setting/mapping',
    name: 'internal-mapping',
    component: () => import('@/views/setting/InternalMapping.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_internal_mapping',
      resource: 'all',
    },
  },
  {
    path: '/setting/bot-mapping',
    name: 'bot-mapping',
    component: () => import('@/views/setting/BotMapping.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_bot_mapping',
      resource: 'all',
    },
  },
  {
    path: '/setting/bot-notifs',
    name: 'bot-notifs',
    component: () => import('@/views/setting/BotNotifications.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_bot_notification',
      resource: 'all',
    },
  },
  {
    path: '/setting/shop',
    name: 'shop-setting',
    component: () => import('@/views/setting/shop_index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_shop_setting',
      resource: 'all',
    },
  },
  {
    path: '/setting/seo',
    name: 'seo-setting',
    component: () => import('@/views/setting/seo.vue'),
    meta: {
      layout: 'content',
      resource: 'all',
      action: 'can_see_seo_menu',
      requiresAuth: true,
    },
  },
  {
    path: '/setting/product-seo',
    name: 'product-seo',
    component: () => import('@/views/setting/productSeo.vue'),
    meta: {
      layout: 'content',
      resource: 'all',
      action: 'can_see_seo_menu',
      requiresAuth: true,
    },
  },
  {
    path: '/setting/FAQ',
    name: 'FAQ',
    component: () => import('@/views/setting/FAQ.vue'),
    meta: {
      layout: 'content',
      resource: 'all',
      action: 'can_see_seo_faq',
      requiresAuth: true,
    },
  },
  {
    path: '/setting/access-gift-carts',
    name: 'access-gift-carts',
    component: () => import('@/views/setting/AccessGiftCart.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_gift_access',
      resource: 'all',
    },
  },
  {
    path: '/setting/gate',
    name: 'gate',
    component: () => import('@/views/setting/gate.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_gate_page',
      resource: 'all',
    },
  },
  {
    path: '/setting/Wallet',
    name: 'wallet-setting',
    component: () => import('@/views/setting/walletManage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_wallet_management',
      resource: 'all',
    },
  },
  {
    path: '/setting/policy',
    name: 'policy-setting',
    component: () => import('@/views/setting/policy.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_policy_setting',
      resource: 'all',
    },
  },
  {
    path: '/setting/security',
    name: 'security-setting',
    component: () => import('@/views/setting/BillSettings.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_bill_safety',
      resource: 'all',
    },
  },
  {
    path: '/setting/auth_user/templates',
    name: 'auth-user-template-setting',
    component: () => import('@/views/setting/authUser/AuthUserIndex.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_auth_user_template',
      resource: 'all',
    },
  },
  {
    path: '/setting/auth_user/samples',
    name: 'auth-user-sample-setting',
    component: () => import('@/views/setting/authUser/AuthUserSamples.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
]
export default access
